import { render, staticRenderFns } from "./StepSecond.vue?vue&type=template&id=fa422f0c&scoped=true&"
import script from "./StepSecond.vue?vue&type=script&lang=js&"
export * from "./StepSecond.vue?vue&type=script&lang=js&"
import style0 from "./StepSecond.vue?vue&type=style&index=0&id=fa422f0c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa422f0c",
  null
  
)

export default component.exports